import { useAppStore } from '@/store/app'
import { modalController } from '@ionic/vue'
import { getTheme } from '@/theme/hooks'
import DefaultModal from '../compulsoryModal/default.vue'
import SecondModal from '../compulsoryModal/second.vue'

/**
 * @description 显示强制安装弹窗
 */
export default async () => {
  const appStore = useAppStore();
  if (appStore.modalVisible) return;  // 如果已经弹出了登录框，则不再弹出
  appStore.modalVisible = true;
 
  const { skin } = getTheme();
  const component = skin === 'second' ? SecondModal : DefaultModal;
  const modal = await modalController.create({
    component,
    id: 'pwa-compulsory-modal',
  });
  modal.onDidDismiss().then(() => {
    useAppStore().modalVisible = false; // 关闭弹窗后，将弹窗状态设置为false
  });
  modal.present();
}
